import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import {getCities} from "models/cities"; // Importing getCities function from cities model
import {getTags} from "models/tags"; // Importing getTags function from tags model
import {getPositions} from "models/positions"; // Importing getPositions function from positions model
import "webix/photo"; // Importing webix photo module
import "webix/tinymce/tinymce"; // Importing TinyMCE editor from webix
import {devConfig} from "../../../config/config"; // Importing development configuration

/**
 * Class representing the search agent view.
 * @extends JetView
 */
export default class searchAgentView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            margin: 5,
            rows: [{
                margin: 15,
                css: "on-row", // CSS class for styling
                cols:[
                {
                    view: "combo", id: "nombre", // Combo box for user name
                    label: "<span class='icon-user'></span>" + _("Nombre del usuario"), // User name label
                    labelPosition:"top", // Position of the label
                    container:"cmb", // Container for the combo
                    options:{
                        body:{
                            dataFeed: function (text) { // Function to fetch data for the combo
                                this.parse(webix.ajax(devConfig.geturlApi() + "Agent/SearchAgentBalance?filter=" + text)); // Fetching data from API
                            }
                        }
                    }
                },
                    {
                    view: "text", id: "idUser", // Text input for user ID
                    label: "<span class='icon-id'></span>" + _("ID del usuario"), // User ID label
                    labelPosition: "top", // Position of the label
                    pattern: {mask: "##########", allow: /[0-9]/g}, // Input mask for user ID
                },
                { id: "grav2", gravity:2 } // Gravity for layout management
                ]}
            ]
        };
        const upper_section = {
             css: "father-container", // CSS class for styling
            rows: [{
                margin: 10,
                cols: [
                    left, // Including the left section
                ]
            }]
        };
        const datos = // Object holding payment data
            {
                ValorPagar: "1.2426", // Amount to pay
                ValorApostado: "1.00", // Amount wagered
                PremioProyectado: "1.24", // Projected prize
                Estado: "Ganador", // Status
                Ganador: "Si" // Winner flag
            };
        const buttons = {
            id:"b2", // ID for the button container
                rows:[{
                    margin:10,
                    responsive: "b2", // Responsive design identifier
                    cols:[
                    { id: "grav", gravity:4}, // Gravity for layout management
                    { id:"aceptar2" }, // Placeholder for secondary button
                    {
                        view: "button", value: _("Continuar"), id:"aceptar", type: "form", width: (screen == "small") ? 0 : 130, minWidth: 200, // Continue button
                        click: () => { // Click event handler
                            let selectedId = $$("idUser").getValue().trim(); // Get trimmed user ID
                            let selectedName = $$("nombre").getValue(); // Get selected user name
                            if (selectedId || selectedName) { // Check if either ID or name is provided
                                const vthis = this; // Reference to the current context
                                webix.ajax().get(devConfig.geturlApi() + "/Agent/GetAgentById", 'id=' + (selectedId || selectedName) , { // Fetch agent data by ID or name
                                    error: function (text, data, XmlHttpRequest) { // Error callback
                                        webix.message(_("Error! ")); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) { // Success callback
                                        var json = JSON.parse(text); // Parse JSON response
                                        if(!json.HasError) { // Check for errors in response
                                            vthis.app.callEvent("agentForm:data", [json.data]); // Trigger event with agent data
                                            $$("formPagoPremio").show(); // Show payment form
                                            $$("formPago").show(); // Show payment form
                                            $$("back-button").show(); // Show back button
                                            $$("consult-section").hide(); // Hide consultation section
                                        }else{
                                            webix.message({title: _("¡Error!"), type:"alert-error", text: _("Usuario no encontrado")}); // Show user not found message
                                        }
                                    }
                                });
                            }
                        }
                    }]}
            ]
        };
        return {
            view: "form", // Main view type
            id: "consult-section", // ID for the consultation section
            height:150, // Height of the form
            width: 0, // Width of the form
            rows: [
                upper_section, // Upper section of the form
                buttons // Button section
            ]
        };
    }
    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        $$("aceptar").hide(); // Hide the continue button initially
        webix.ready(function(){ // Wait for webix to be ready
                if (screen.width < 500){ // Check screen width
                    $$("grav").hide(); // Hide gravity element for small screens
                    $$("grav2").hide(); // Hide gravity element for small screens
                }
            });
        $$("nombre").attachEvent("onChange", function(newv, oldv){ // Event listener for changes in the name combo
            if(newv >0){ // Check if new value is valid
                $$("aceptar").show(); // Show continue button
                $$("aceptar2").hide(); // Hide secondary button
            }
        });
        $$("idUser").attachEvent("onTimedKeyPress", function(){ // Event listener for timed key press in user ID input
            if (this.getValue().length > 0){ // Check if input has value
                $$("aceptar").show(); // Show continue button
                $$("aceptar2").hide(); // Hide secondary button
            }
        });
        this.on(this.app, "TransferAgentSuccess", premio => { // Event listener for successful agent transfer
            this.getRoot().clear(); // Clear the form
            $$("aceptar").hide(); // Hide continue button
            $$("nombre").setValue(""); // Clear name input
            $$("idUser").setValue(""); // Clear user ID input
        });
    }
}

// FILE DOCUMENTED
